import client from '../../client';
import type {
  IDeleteDispatchDeviceParams,
  IDispatchListParams,
  IGetDispatchedDeviceDetailParams,
  IGetDispatchByMacParams,
  IGetDispatchHistoryParams,
  IPostDispatchDevicesParams,
  IPutDispatchDevicesParams,
  IUnDispatchedListParams,
  TPostBulkDispatchDevicesParams,
} from './types';

export const deviceShipmentApis = {
  getDispatchList: (data: IDispatchListParams) => client.get('/device/shipment', { params: data }),
  getDispatchTemplate: () => client.get('/device/shipment/download-excel', { responseType: 'blob' }),
  deleteDispatchDevice: (data: IDeleteDispatchDeviceParams) => client.post('/device/shipment/delete', data),
  postBulkDispatchDevices: (formData: TPostBulkDispatchDevicesParams) =>
    client.post('/device/shipment/upload-excel', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }),
  getUnDispatchedList: (data: IUnDispatchedListParams) => client.get('/device/shipment/unshipped', { params: data }),
  postDispatchDevices: (data: IPostDispatchDevicesParams) => client.post('/device/shipment', data),
  getDispatchHistory: (data: IGetDispatchHistoryParams) =>
    client.get(`/device/shipment/${data.mac}`, {
      params: {
        page: data.page,
        size: data.size,
        channel: data.channel,
      },
    }),
  getDispatchedDeviceDetail: (data: IGetDispatchedDeviceDetailParams) => client.get(`/device/shipment/detail/${data.id}`),
  putDispatchDevices: (data: IPutDispatchDevicesParams) =>
    client.put(`/device/shipment/${data.id}`, {
      fromCompanyId: data.fromCompanyId,
      toCompanyId: data.toCompanyId,
      memo: data.memo,
    }),
  getDispatchByMac: (data: IGetDispatchByMacParams) => client.get(`/device/shipment/by-mac`, { params: data }),
};
